<script setup lang="ts">
import type { EsProductFragment } from '#graphql-operations'

const { disabled } = defineProps<{ disabled: boolean }>()

const product = inject('esProduct') as EsProductFragment

const prices = computed(() => {
  if (product.value.fromPrice) {
    return {
      regularPrice: product.value.fromPrice,
      finalPrice: product.value.fromPrice,
    }
  }
  return {
    regularPrice: product.value.regularPrice,
    finalPrice: product.value.finalPrice,
  }
})

const showSticky = ref(false)

onMounted(() => {
  showSticky.value = true
})
</script>

<template>
  <div
    v-if="product && showSticky"
    class="add-to-cart-sticky"
  >
    <div class="add-to-cart-sticky__visual">
      <img
        :src="useXcdnImage(product.image, 'f=rs:fit:112:112', product.name)"
        class="add-to-cart-sticky__image"
        height="112"
        width="112"
        loading="lazy"
        fetchpriority="low"
      >
    </div>

    <div class="add-to-cart-sticky__name">
      {{ product?.mainTitle || product.name }}
    </div>
    <UiPrice
      class="add-to-cart-sticky__price"
      :prices="prices"
    >
      <template
        v-if="product.fromPrice"
        #prefix
      >
        v.a.
      </template>
    </UiPrice>

    <button
      :disabled="disabled"
      class="add-to-cart-sticky__button"
      @click="$emit('add-to-cart')"
    >
      <span>{{ $t('Add to cart') }}</span>
      <NuxtIcon name="icon:shoppingcart" />
    </button>
  </div>
</template>

<style>
@import url("~layers/components/Product/AddToCartSticky.css");
</style>
